import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { RelatedItemInterface } from '../model/related-item.interface';

@Component({
  selector: 'app-related-items-history',
  templateUrl: './related-items-history.component.html',
  styleUrls: ['./related-items-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelatedItemsHistoryComponent {
  icons = { faArrowLeft };
  @Input() history: RelatedItemInterface[] = [];

  @Output() selectedObjectEmitter: EventEmitter<{item: RelatedItemInterface, index: number}> =
    new EventEmitter<{item: RelatedItemInterface, index: number}>();

  onSelectedObject(item: RelatedItemInterface, index: number) {
    this.selectedObjectEmitter.emit({item, index});
  }
}
